import { render } from "./MuseumPremialitaA.vue?vue&type=template&id=331c26b4"
import script from "./MuseumPremialitaA.vue?vue&type=script&lang=js"
export * from "./MuseumPremialitaA.vue?vue&type=script&lang=js"

import "./MuseumPremialitaA.vue?vue&type=style&index=0&id=331c26b4&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__